// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { updatePartNumbers } from "@vanmeter/App/Services/CustomerPartNumbersService";

type HandlerType = ApiHandler<HasOnSuccess<any> & HasOnError<string> & any, any>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await updatePartNumbers(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const updateCustomerPartNumbers = createHandlerChainRunner(chain, "updateCustomerPartNumbers");
export default updateCustomerPartNumbers;
